import Footer from "../components/Footer";

const RefundPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Refund Policy</h1>

      <p className="mb-4">
        This Refund Policy applies to all services provided by{" "}
        <strong>Bill-lex.com</strong>, a product of{" "}
        <strong>Lexora Technologies OPC Private Limited</strong>. Please read
        this policy carefully before making any payments for our services.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">1. No Refund Policy</h2>
      <p className="mb-4">
        <strong>
          Bill-lex.com operates on a strict no-refund policy for all services
          and subscriptions.
        </strong>{" "}
        Once a payment is processed and your account is activated, we do not
        provide refunds, credits, or partial reimbursements under any
        circumstances.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        2. Service Activation
      </h2>
      <p className="mb-4">
        Upon successful payment processing, your Bill-lex.com account is
        immediately activated with full access to all purchased features and
        services. The activation is considered final and binding, and no refunds
        will be issued once the service is activated.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        3. Subscription Services
      </h2>
      <p className="mb-4">For subscription-based services:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>No refunds are provided for partial months or unused periods</li>
        <li>Subscription fees are non-refundable once charged</li>
        <li>Cancellation of subscription does not entitle you to a refund</li>
        <li>
          You may continue using the service until the end of your current
          billing period
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">4. One-Time Payments</h2>
      <p className="mb-4">
        For one-time payments, upgrades, or add-on services:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>All payments are final and non-refundable</li>
        <li>No refunds for unused features or services</li>
        <li>Payment processing fees are non-refundable</li>
        <li>Service activation is considered acceptance of this policy</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        5. Payment Processing
      </h2>
      <p className="mb-4">
        All payments are processed through our secure payment partner, Cashfree.
        Payment processing fees and charges are non-refundable, and we do not
        reimburse any transaction costs or bank charges incurred during payment.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        6. Service Availability
      </h2>
      <p className="mb-4">
        While we strive to maintain high service availability, temporary service
        interruptions due to maintenance, updates, or technical issues do not
        qualify for refunds. We are not liable for any losses resulting from
        service downtime.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        7. Account Termination
      </h2>
      <p className="mb-4">
        If your account is terminated due to violation of our Terms and
        Conditions or for any other reason, no refunds will be provided. You
        forfeit all rights to any unused service period or features.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">8. Change of Mind</h2>
      <p className="mb-4">We do not provide refunds for:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Change of mind or decision to discontinue service</li>
        <li>Failure to use the service after activation</li>
        <li>Dissatisfaction with service features or functionality</li>
        <li>Technical issues on the user's end</li>
        <li>Incompatibility with user's systems or requirements</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">9. Billing Disputes</h2>
      <p className="mb-4">
        If you believe there has been an error in billing, please contact our
        support team immediately. We will investigate the matter, but please
        note that our no-refund policy remains in effect for all valid charges.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">10. Exceptions</h2>
      <p className="mb-4">
        <strong>There are no exceptions to our no-refund policy.</strong> This
        policy applies to all users, including new customers, existing
        customers, and customers upgrading or downgrading their services.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        11. Payment Method Refunds
      </h2>
      <p className="mb-4">
        We do not process refunds to original payment methods. If you have
        concerns about a payment, please contact our support team for
        assistance. However, please note that refunds will not be issued
        regardless of the circumstances.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">12. Acknowledgment</h2>
      <p className="mb-4">
        By making a payment for our services, you acknowledge and agree to this
        no-refund policy. You confirm that you have read, understood, and accept
        these terms before proceeding with any payment.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        13. Contact Information
      </h2>
      <p className="mb-4">
        For questions about this Refund Policy or billing-related inquiries,
        please contact us at{" "}
        <a
          href="mailto:billlex.owner@gmail.com"
          className="text-blue-600 underline"
        >
          billlex.owner@gmail.com
        </a>
        . Please note that refund requests will not be processed.
      </p>

      <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <p className="text-yellow-800 font-semibold">
          <strong>Important Notice:</strong> All payments made to Bill-lex.com
          are final and non-refundable. Please ensure you understand our
          services and pricing before making any payment.
        </p>
      </div>

      <p className="mt-8 text-sm text-gray-600">
        <strong>Last updated:</strong> December 2024
      </p>

      <Footer />
    </div>
  );
};

export default RefundPolicy;
